<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Attributs</h1>
                    <p>Gestion des attributs</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxcore.attribute.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer un attribut</span>
                </li>
                <!--
                <li v-if="$aclInterfaceValidator('weeboxcore.attribute.export')" @click="exportFile('contacts')">
                  <icon name="download-cloud-01"/>
                  <span>Export les résultats (Excel)</span>
                </li>
                -->
                <li v-if="$aclInterfaceValidator('weeboxcore.attribute.import')" @click="importFile()">
                  <icon name="upload-cloud-01"/>
                  <span>Importer</span>
                </li>
              </actions-dropdown>

            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" active-advanced-filter="false" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

                <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                    <div class="datagrid-header">
                        <div>
                            <div></div>
                            <div class="picture"></div>
                            <div>
                              <datagrid-sort :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Référence', value:'slug'}]" v-model="paginator"></datagrid-sort>
                            </div>
                          <div class="center">
                            <datagrid-sort :data="[{name:'Attribut de produits', value:'allowed_for_products'}]" v-model="paginator"></datagrid-sort>
                          </div>
                            <div>
                              <datagrid-sort :data="[{name:'Type', value:'type'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div class="center"><span>Global</span></div>
                            <div><span>Parent</span></div>
                            <div class="actions"></div>
                            <div></div>
                        </div>
                    </div>
                    <div class="datagrid-body">
                        <div v-for="item in resources" @dblclick="edit(item.id)" v-bind:class="setClassDataRaw( 'weeboxcore.attribute.view', item.id )">
                            <div></div>
                            <div class="picture no-radius">
                                <figure>
                                    <i class="icon icon-icon_tags"></i>
                                </figure>
                            </div>
                            <div data-field="name"><strong class="highlight">{{ item.name }}</strong></div>
                            <div data-field="slug" style="white-space: nowrap;">{{ item.slug }}</div>
                            <div data-field="allowed_for_products" class="center">
                              <checked v-model="item.allowed_for_products"></checked>
                            </div>
                            <div data-field="type" style="white-space: nowrap;">{{ item.type }}</div>
                            <div data-field="is_global" class="center">
                              <checked v-model="item.is_global"></checked>
                            </div>
                            <div data-field="parent" style="white-space: nowrap;">{{ item.parent ? item.parent.slug : '' }}</div>
                            <div class="actions">
                                <ul>
                                    <li v-if="$aclInterfaceValidator('weeboxcore.attribute.delete', item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                    <li v-if="$aclInterfaceValidator('weeboxcore.attribute.update', item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                                </ul>
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import AttributeService from './AttributeService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return AttributeService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/config/attribute/Index.vue